module.exports = __webpack_public_path__ + "media/images/emblems/Les_Genevez_Blazono-4c8a6ee824a6d2740f3c987286f23653.png";